export const writeManipForType = (type, manip) => JSON.stringify(manip);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/api/json.js